export default __webpack_public_path__ + "8c305a0.png";